import { axiosInstance } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";

export default {
  getConfig() {
    return axiosInstance.get(endpoints.storeLocator.config);
  },

  saveConfig(id, data) {
    return axiosInstance.patch(endpoints.storeLocator.configCompany(id), data);
  },

  saveFile(id, file, fileType) {
    const formData = new FormData();
    formData.append(fileType, file);
    return axiosInstance.patch(
      endpoints.storeLocator.configCompany(id),
      formData
    );
  },

  saveFacilities(data) {
    if (data === "all") {
      return axiosInstance.post(endpoints.storeLocator.facilities, {
        show_all: true
      });
    }

    return axiosInstance.post(endpoints.storeLocator.facilitiesGroups, {
      facility_groups_ids: data
    });
  },

  getExtraInfo(facilityId) {
    return axiosInstance.get(endpoints.storeLocator.extraInfo(facilityId));
  },

  updateExtraInfo(facilityId, data) {
    return axiosInstance.patch(
      endpoints.storeLocator.extraInfo(facilityId),
      data
    );
  },

  getExtraInfoSections(facilityId) {
    return axiosInstance.get(
      endpoints.storeLocator.extraInfoSections(facilityId)
    );
  },

  createExtraInfoSection(facilityId, data) {
    return axiosInstance.post(
      endpoints.storeLocator.extraInfoSections(facilityId),
      data
    );
  },

  updateExtraInfoSection(facilityId, sectionId, data) {
    return axiosInstance.patch(
      endpoints.storeLocator.extraInfoSection(facilityId, sectionId),
      data
    );
  },

  deleteSection(facilityId, sectionId) {
    return axiosInstance.delete(
      endpoints.storeLocator.extraInfoSection(facilityId, sectionId)
    );
  },

  getDefaultFaq() {
    return axiosInstance.get(endpoints.storeLocator.defaultFaq);
  },

  getFacilityFaq(facilityId) {
    return axiosInstance.get(endpoints.storeLocator.facilityFaq(facilityId));
  },

  postDefaultFaq(data) {
    return axiosInstance.post(endpoints.storeLocator.defaultFaq, data);
  },

  postFacilityFaq(facilityId, data) {
    return axiosInstance.post(
      endpoints.storeLocator.facilityFaq(facilityId),
      data
    );
  },

  patchDefaultFaq(id, data) {
    return axiosInstance.patch(endpoints.storeLocator.defaultFaqById(id), data);
  },

  deleteDefaultFaq(id) {
    return axiosInstance.delete(endpoints.storeLocator.defaultFaqById(id));
  },

  patchFacilityFaq(facilityId, data) {
    return axiosInstance.patch(
      endpoints.storeLocator.facilityFaqItem(facilityId, data.id),
      data.payload
    );
  },

  deleteFacilityFaq(facilityId, itemId) {
    return axiosInstance.delete(
      endpoints.storeLocator.facilityFaqItem(facilityId, itemId)
    );
  }
};
